import { render, staticRenderFns } from "./AdminPanelEGiftsList.vue?vue&type=template&id=c41a7d5c&"
import script from "./AdminPanelEGiftsList.vue?vue&type=script&lang=js&"
export * from "./AdminPanelEGiftsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports